export const currencyMap: Record<string, string> = {
  AED: 'د.إ',
  AMD: '\u058F',
  CHF: 'Fr',
  EUR: '\u20AC',
  GBP: String.fromCharCode(163),
  USD: String.fromCharCode(36),
};

export const getCurrencySymbol = (currency: string) =>
  currencyMap[currency] || currency;
